import React, { useState } from "react";
import { FRONTEND_URL } from "../config/axios";
import { useLocation, useNavigate } from "react-router-dom";
import UserProfileMenu from "../Component/Common/UserProfileMenu";
// import Createnewall from "../components/Modals/Createnewall";

const Dashboardnavbar = ({ name, url, sector, setSector }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);

  const location = useLocation();
  const navigate = useNavigate();

  const [activeButton, setActiveButton] = useState(null);
  const [hoveredButton, setHoveredButton] = useState(null); // Track hover state

  const handleClick = (buttonName, path) => {
    setActiveButton(buttonName);
    navigate(path);
  };
  const [toggleState, setToggleState] = useState(0);

  const getStrokeColor = (buttonName) => {
    if (
      (buttonName === "railways" &&
        location.pathname === "/ed/railwaysprojects") ||
      (buttonName === "highways" && location.pathname === "/ed/highwayprojects")
    ) {
      return "white";
    }
    return "#707070";
  };
  const [showttext, Setshowtext] = useState(false);
  const isActive = (path) => location.pathname === path;

  const handleopen = () => Setshowtext(true);
  const handleclosetext = () => Setshowtext(false);
  const handleBackgroundColor = () => {
    if (location.pathname === "/ed/railwaysprojects") {
      setToggleState(1);
    } else if (activeButton === "highways") {
      setToggleState(2);
    } else {
      setToggleState(0);
    }
  };

  return (
    <div className="navbar-section-main">
      <div className="navbar-margin-left">
        <div className="navbar-heading font-weight700">{name}</div>
      </div>
      <div className="navbar-subsection navbar-margin-right">
        <div>{/* <Createnewall /> */}</div>
        <div className="navbar-subsection-b">
          <div className="navbar-logo" style={{ float: "right" }}>
            <UserProfileMenu />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboardnavbar;
